import React, {useContext} from 'react';
import { useNewsNotification } from '../hooks/useNewsNotification';
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import UserContext from "../context/UserContext";
import CampaignContext from "../context/CampaignContext";
import '../styles/headerbar.css';
import i18next from 'i18next';
import logo from '../assets/Images/logo150.png';
import {Link} from "react-router-dom";
import { ChevronDownIcon } from '@heroicons/react/solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNewspaper, faCog, faBook, faDungeon, faShieldAlt } from '@fortawesome/free-solid-svg-icons'

const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL;

const HeaderBar = (props) => {
  const {user, updateUser} = useContext(UserContext);
  const {campaign} = useContext(CampaignContext) || {};
  const hasUnreadNews = useNewsNotification();
  return (
    <header>
      <div className='header'>
        <div className='logo'>
          <Link className={'link homeLink'} to="/campaigns">
            <img src={logo} className="homeLinkIcon" alt="Logo" />
          </Link>
        </div>
        <div className='log'>
          {campaign?.uid && (
            <Link className='headLinkText' to={`/campaigns/${campaign.uid}`}>
              <span>{campaign.name || i18next.t('campaign')}</span>
              <FontAwesomeIcon className='icon' icon={faDungeon}/>
            </Link>
          )}
          <Link
            className='headLinkText'
            to={`/news`}>
            <span className='newsLinkInner'>
              {i18next.t('news')}
              {hasUnreadNews && <span className='newsBadge' />}
            </span>
            <FontAwesomeIcon className='icon' icon={faNewspaper}/>
          </Link>
          <Link className='headLinkText' to="/library">
            <span>{i18next.t('library.title')}</span>
            <FontAwesomeIcon className='icon' icon={faBook}/>
          </Link>
          {user?.email === ADMIN_EMAIL && (
            <Link className='headLinkText' to="/admin">
              <span>Admin</span>
              <FontAwesomeIcon className='icon' icon={faShieldAlt}/>
            </Link>
          )}
          <Link className='headLinkText' to="/settings">
            <span>{i18next.t('settings')}</span>
            <FontAwesomeIcon className='icon' icon={faCog}/>
          </Link>
          <a className='headLinkText kofiLink' href="https://ko-fi.com/praythedice" target="_blank" rel="noreferrer">
            <span>Ko-fi</span>
            <svg className='icon' viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.881 8.948c-.773-4.085-4.859-4.593-4.859-4.593H.723c-.604 0-.679.798-.679.798s-.082 7.324-.022 11.822c.164 2.424 2.586 2.672 2.586 2.672s8.267-.023 11.966-.049c2.438-.426 2.683-2.566 2.658-3.734 4.352.24 7.422-2.831 6.649-6.916zm-11.062 3.511c-1.246 1.453-4.011 3.976-4.011 3.976s-.121.119-.31.023c-.076-.057-.108-.09-.108-.09-.443-.441-3.368-3.049-4.034-3.954-.709-.965-1.041-2.7-.091-3.71.951-1.01 3.005-1.086 4.363.407 0 0 1.565-1.782 3.468-.963 1.904.82 1.832 3.011.723 4.311zm6.173.478c-.928.116-1.682.028-1.682.028V7.284h1.77s1.971.551 1.971 2.638c0 1.913-.985 2.667-2.059 3.015z"/>
            </svg>
          </a>
          <div className="dropdown">
            <button className={'dropbtn main'}>
              {user.name} <ChevronDownIcon style={{height:15, marginLeft: 2}}/>
            </button>
            <div className="dropdown-content">
              <Link className="btnDropLink" to="/">{i18next.t('home.switchGame')}</Link>
              <button
                className="btnDrop"
                onClick={() => {
                  updateUser({
                    uid: null,
                    displayName: null,
                  });
                  firebase.auth().signOut();
                }}
              >
                {i18next.t('logout')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
export default HeaderBar